import React from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';
import { BadgeCardProps } from '../model';

const BadgeCard: React.FC<BadgeCardProps> = ({ title, site, description }) => {
  return (
    <Box spacingInset="300" className="badge-card">
      <Column spacing="200">
        <Text type="h100">{title}</Text>
        <Heading type="h300" level={4}>
          {site}
        </Heading>
        <Text type="b200" color="secondary">
          {description}
        </Text>
      </Column>
    </Box>
  );
};

export default BadgeCard;
